import type { TFunction } from 'i18next'
import { TransactieType } from '../types/api'
import type { CollectingType, ReturningType } from '../types/transactions'

type TransactionTypeInput =
  | CollectingType
  | ReturningType
  | TransactieType
  | string
  | number

const transactionTypeTranslationKeyByBackendValue: Record<string, string> = {
  UitgifteDock: 'transactionType.UitgifteDock',
  UitgifteMobiel: 'transactionType.UitgifteMobiel',
  UitgifteVast: 'transactionType.UitgifteVast',
  InnameVast: 'transactionType.InnameVast',
  InnameMobiel: 'transactionType.InnameMobiel',
}

export const normalizeTransactionType = (
  transactionType: TransactionTypeInput
): string => {
  if (typeof transactionType === 'number') {
    const enumLabel = TransactieType[transactionType]
    return typeof enumLabel === 'string' ? enumLabel : String(transactionType)
  }

  return String(transactionType)
}

export const transactieTypeMapper = (
  transactieType: TransactionTypeInput,
  t: TFunction
): {
  label: string
  value: string
} => {
  const normalizedType = normalizeTransactionType(transactieType)
  const translationKey =
    transactionTypeTranslationKeyByBackendValue[normalizedType]

  return {
    label: translationKey ? t(translationKey) : normalizedType,
    value: normalizedType,
  }
}

export const mapTransactionTypeLabel = (
  transactieType: TransactionTypeInput,
  t: TFunction
): string => transactieTypeMapper(transactieType, t).label
